// Friendly 404 / 403 stub rendered inside `RussiaRequestDrawer` when
// `useRussiaRequest(id)` errors (#944). Mirrors china's stub.
//
// INVARIANT: this component MUST NOT receive `RussiaRequest` or query
// state and MUST NOT import the row type. The warm-cache 404 leak
// (react-query retains `data` after a failed refetch even though the
// user is no longer authorized to see it) is closed by construction:
// there is no symbol the component can reach to render row data.
// `requestId` is sourced from the URL — user input, not server data.

import { useTranslation } from 'react-i18next';
import { Icon } from '../../../ui/index.js';

export function RussiaRequestDrawerUnavailableStub({
  requestId,
  onClose,
}: {
  requestId: string;
  onClose: () => void;
}) {
  const { t } = useTranslation(['russiaRequests', 'common']);
  return (
    <div
      data-testid="russia-request-drawer-unavailable"
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        background: 'var(--bg-1)',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '12px 16px' }}>
        <button
          type="button"
          onClick={onClose}
          aria-label={t('common:actions.close')}
          title={t('common:actions.close')}
          data-testid="russia-request-drawer-unavailable-close"
          style={{
            width: 28,
            height: 28,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 'none',
            background: 'transparent',
            borderRadius: 'var(--r-1)',
            cursor: 'pointer',
            color: 'var(--fg-2)',
          }}
        >
          <Icon name="x" size={18} />
        </button>
      </div>
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
          padding: '0 24px',
        }}
      >
        <h2 style={{ margin: 0, fontSize: 18, fontWeight: 600, color: 'var(--fg-1)' }}>
          {t('russiaRequests:drawer.unavailable.title')}
        </h2>
        <span
          style={{
            fontFamily: 'var(--font-mono)',
            fontSize: 12,
            color: 'var(--fg-3)',
          }}
        >
          {requestId}
        </span>
      </div>
    </div>
  );
}
